import React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

const ConfirmModal = ({ open, content, onClose, children, disableBackdropClick}) => {
  return (
    <div>
      <Dialog
        open={open}
        onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
                onClose(event, reason)
            }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">Seasonal Tokens Trading Simulator</DialogTitle>
        <DialogContent>
          {content}
          {children}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ConfirmModal
